import type { Entity } from '@tunasong/schemas'

export const DROP_BOTTOM = 1
export type DropTarget = Entity | typeof DROP_BOTTOM
